<!-- NOTE: We are using material icons. Please search online to use it -->
<template>
  <div class="mt-4">
    <h1>View Invoice</h1>

    <vs-table>
      <template #header>
        <div>
          <span class="span1">Due Date :{{ getDate(InvoList.dueDate) }}</span>
          <span class="span2">Due Amount :{{ InvoList.dueAmount }}</span>
        </div>
      </template>
      <template #thead>
        <vs-tr>
          <vs-th style="width: 55%"> Transaction Type </vs-th>
          <vs-th> Amount</vs-th>
        </vs-tr>
      </template>
      <template #tbody>
        <vs-tr :key="i" v-for="(tr, i) in $vs.getSearch(InvoList)" :data="tr">
          <vs-td>
            {{ tr.transaction }}
          </vs-td>
          <vs-td>
            {{ tr.amount }}
          </vs-td>
        </vs-tr>
      </template>
    </vs-table>
  </div>
</template>
<script>
import { getBillDetails } from "@/services/dashboard";
import moment from "moment";

export default {
  data: () => ({
    id: ""
  }),
  computed: {
    userInfo() {
      return this.$store.getters["auth/getUser"];
    },
    InvoList() {
      return this.$store.getters["dashboard/getInvoicesDetails"];
    }
  },

  methods: {
    getDate(date) {
      return moment(date).format("DD MMMM YYYY");
    }
  },
  filters: {},
  async mounted() {
    this.id = this.$route.params.id;
    await this.$store.dispatch("dashboard/getInvoicesDetails", this.id);
  }
};
</script>
<style lang="scss" scoped>
.invoice-card {
  background: linear-gradient(135deg, #6572bb 0%, #2b3674 100%);
  width: 100%;
  padding: 20px;
  color: #ffffff;
  border-radius: 16px;
}
.amount {
  font-size: 22px;
  font-weight: 700;
  margin-top: 5px;
}
.pay-now {
  margin-left: 5rem;
  background: #fff;
  color: #2b3674;
  padding: 2px 10px;
}
.generate {
  margin-left: 1rem;
  background: #fff;
  color: #2b3674;
  padding: 2px 10px;
}
.w-300 {
  width: 300px;
  max-width: 40%;
  max-height: 35px;
}
@media (max-width: 300px) {
  .pay-now {
    margin-left: 3rem;
  }
}
.span2 {
  margin-left: 200px;
}
</style>
